import COS_SUBCATEGORY from 'ui-forms-components/constants/COSSubcategory';
import Categories from 'ContentUtils/constants/Categories';
import Routes from 'ContentUtils/Routes';
import Log from 'forms-utils-lib/logger/Logger';
function getCategoryIdForCOSSubcategory(subcategory) {
  switch (subcategory) {
    case COS_SUBCATEGORY.LANDING_PAGE:
      return Categories['landing-page'].id;
    case COS_SUBCATEGORY.SITE_PAGE:
      return Categories['site-page'].id;
    case COS_SUBCATEGORY.BLOG_POST:
      return Categories['blog-post'].id;
    case COS_SUBCATEGORY.BLOG_LISTING_PAGE:
      return Categories['blog-listing-page'].id;
    case COS_SUBCATEGORY.WEB_INTERACTIVE:
      return Categories['web-interactive'].id;
    case COS_SUBCATEGORY.PORTAL_CONTENT:
      return Categories['portal-content'].id;
    default:
      Log.warn(`Could not get COS type for unknown subcategory '${subcategory}'.`);
      return Categories.unmapped.id;
  }
}
export function getContentDetailsRoute(contentId, subcategory) {
  return Routes.details(contentId, getCategoryIdForCOSSubcategory(subcategory));
}
export function getContentEditorRoute(contentId, subcategory) {
  return Routes.edit(contentId, getCategoryIdForCOSSubcategory(subcategory));
}